import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainDetailsComponent } from './containers/main-details/main-details.component';
import { ProductDetailsComponent } from './containers/product-details/product-details.component';
import { CartFormComponent } from './containers/cart-form/cart-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { RouterModule } from '@angular/router';
import { SnatchModule } from '../snatch/snatch.module';
import { CommonUtilsModule } from '../common/common-utils/common-utils.module';
import { ProductDetailsState } from './state/product-details.state';
import { NgxsModule } from '@ngxs/store';
import { ChooseVariantFormComponent } from './components/choose-variant-form/choose-variant-form.component';
import { AboutComponent } from './components/about/about.component';
import { CourseInformationComponent } from './components/course-information/course-information.component';
import { ContentComponent } from './components/content/content.component';
import { HowToAccessComponent } from './components/how-to-access/how-to-access.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { QAndAComponent } from './components/q-and-a/q-and-a.component';
import { DeliveryAndSpecificationsComponent } from './components/delivery-and-specifications/delivery-and-specifications.component';
import { UrlStorageService } from './services/url-storage.service';
import { ProductDetailsService } from './services/product-details.service';
import { ProductDetailsImageSkeletonComponent } from './components/product-details-image-skeleton/product-details-image-skeleton.component';
import { ProductMainDetailsSkeletonComponent } from './components/product-main-details-skeleton/product-main-details-skeleton.component';
import { ProductTabContentSkeletonComponent } from './components/product-tab-content-skeleton/product-tab-content-skeleton.component';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { ReviewItemComponent } from "./components/reviews/review-item/review-item.component";
import { SegmentInformationComponent } from './components/segment-information/segment-information.component';
import { ExpiringContractAlertComponent } from './components/expiring-contract-alert/expiring-contract-alert.component';
import { LicenseAgreementComponent } from './components/license-agreement/license-agreement.component';
import { ProductDetailsCartFormSkeletonComponent } from './components/product-details-cart-form-skeleton/product-details-cart-form-skeleton.component';
import { BottomAnchorComponent } from './containers/bottom-anchor/bottom-anchor.component';
import {RelatedProductsCarouselComponent} from "./components/related-products-carousel/related-products-carousel.component";
import {CommonProductModule} from "../common/common-product/common-product.module";
import {ProductAddOrderTemplatesComponent} from "./components/product-add-order-templates/product-add-order-templates.component";
import {ProductCartFormGenericDetailsComponent} from "./components/product-cart-form-generic-details/product-cart-form-generic-details.component";
import { OrderTemplatesService } from "../order-templates/services/order-templates.service";
import { MediaComponent } from './components/media/media.component';
import { MediaVideoModalComponentComponent } from './components/media/media-video-modal-component/media-video-modal-component.component';
import { MediaCardComponent } from './components/media/media-card/media-card.component';
import {RelatedBundlesComponent} from "./components/related-bundles/related-bundles.component";
import {
  RelatedBundlesItemComponent
} from "./components/related-bundles/related-bundles-item/related-bundles-item.component";
import {IncludedProductsComponent} from "./components/included-products/included-products.component";
import {
  IncludedProductsItemComponent
} from "./components/included-products/included-products-item/included-products-item.component";
import {BundleLicenseFormComponent} from "./components/bundle-license-form/bundle-license-form.component";

@NgModule({
  declarations: [
    MainDetailsComponent,
    ProductDetailsComponent,
    CartFormComponent,
    ChooseVariantFormComponent,
    AboutComponent,
    CourseInformationComponent,
    ContentComponent,
    HowToAccessComponent,
    ReviewsComponent,
    ReviewItemComponent,
    QAndAComponent,
    DeliveryAndSpecificationsComponent,
    ProductDetailsImageSkeletonComponent,
    ProductMainDetailsSkeletonComponent,
    ProductTabContentSkeletonComponent,
    SegmentInformationComponent,
    ExpiringContractAlertComponent,
    LicenseAgreementComponent,
    ProductDetailsCartFormSkeletonComponent,
    BottomAnchorComponent,
    RelatedProductsCarouselComponent,
    ProductAddOrderTemplatesComponent,
    ProductCartFormGenericDetailsComponent,
    MediaComponent,
    MediaVideoModalComponentComponent,
    MediaCardComponent,
    RelatedBundlesComponent,
    RelatedBundlesItemComponent,
    IncludedProductsComponent,
    IncludedProductsItemComponent,
    BundleLicenseFormComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    NgxsModule.forFeature([ProductDetailsState]),
    NgxsFormPluginModule,
    RouterModule.forChild([
      {
        path: '',
        component: ProductDetailsComponent,
        children: []
      },
      {
        path: ':variant-sku',
        component: ProductDetailsComponent,
        children: []
      }
    ]),
    SnatchModule,
    CommonUtilsModule,
    CommonProductModule
  ],
  providers: [ ProductDetailsService, UrlStorageService, OrderTemplatesService ]
})
export class ProductDetailsModule { }
